export const E2E_TOKEN_NAME = 'X-Access-Token';
export const E2E_INTL_HEADER = 'Accept-Language';

export const E2E_LANGUAGE_STORAGE_KEY = 'locale'; // 国际化 在 localstorage 存储的key

export const E2E_FILE_TYPE_ENUM = {
  pdf: ['pdf'],
  image: ['png', 'jpg', 'jpeg', 'svg', 'gif'],
  excel: ['xls', 'xlsx'],
  word: ['doc', 'docx'],
  ppt: ['ppt', 'pptx'],
  msg: ['msg'],
  video: ['mp4', 'mpeg', 'avi', 'asf', 'mov', '3gp', 'wmv', 'rm', 'rmvb', 'flv', 'f4v']
};

// filebox 组件中 选择的支持上传的文件类型对应显示的名称信息
export const File_Type_Name_Mapping = {
  pdf: {
    en: 'PDF',
    zh: 'PDF'
  },
  image: {
    en: 'Image',
    zh: 'Image'
  },
  excel: {
    en: 'Excel',
    zh: 'Excel'
  },
  word: {
    en: 'Word',
    zh: 'Word'
  },
  ppt: {
    en: 'PPT',
    ZH: 'PPT'
  },
  msg: {
    en: 'Msg',
    zh: 'Msg'
  }
};

// quarterly plan 状态和 value 的对应值
export const Quarterly_Plan_Status_Enum = {
  draft: {
    text: 'quarterlyPlan.label.draft', // 国际化 key
    value: 1
  },
  inprogress: {
    text: 'quarterlyPlan.label.inprogress',
    value: 2
  },
  todo: {
    text: 'quarterlyPlan.label.todo',
    value: 3
  },
  approved: {
    text: 'quarterlyPlan.label.approved',
    value: 4
  },
  rejected: {
    text: 'quarterlyPlan.label.rejected',
    value: 5
  }
};

export const E2E_MAP_KEY = '4660673a7aff6e995fec5bcc74caf03a';



// WEBPACK FOOTER //
// ./src/constant/common.js